import React, { useMemo } from "react";
import { Stack } from "@mui/material";

import ConfigHeader from "../ConfigHeader/config-header";
import ConfigPackageBundleForm from "./ConfigPackageBundleForm/config-transcode-bundle-form";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import { ConfigBaseProps } from "../../../Pages/Basket/basket";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { FormExists, GetFormIsValid } from "../../../Redux/Reducers/redux-slice-form-validation";
import { UpdateItemStatusOnBasket } from "../../../Redux/Reducers/redux-slice-basket";
import { BasketItemStatus } from "../../../Core/Api/Types/basket-item-status";
import ConfigSaveButton from "../ConfigSaveButton/config-save-button";
import ConfigCommonSectionFormScheduling from "../ConfigCommon/config-common-section-form-scheduling";
import { useTranslation } from "react-i18next";

interface ConfigPackageBundleProps extends ConfigBaseProps {}

const ConfigPackageBundle: React.FC<ConfigPackageBundleProps> = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, handleCancel, handleChangeProduct, item, ...otherProps } = props;
  const formId = `form-bundle-${item.id}`;
  const formValid = useAppSelector(GetFormIsValid(formId));
  const formExists = useAppSelector(FormExists(formId));
  const dispatch = useAppDispatch();

  const formValidTrigger = useMemo(() => {
    // In case of invalid, update item status
    if (!formValid && formExists && item.status !== BasketItemStatus.OptionsDone)
      dispatch(UpdateItemStatusOnBasket({ itemId: item.id, status: BasketItemStatus.New }));

    return formValid;
  }, [formValid, formExists]);

  return (
    <Stack width={"100%"} {...props}>
      <ConfigHeader
        configType={OrderProductType.TranscodeBundleByProfile}
        title={t("component:configTranscodeBundleByProfile.body.configHeaderTitle", {
          name: item.selectedBroadcaster?.name?.replace("[BundleMaker]", ""),
        })}
        handleCancel={handleCancel}
        handleChangeProduct={handleChangeProduct}
        sx={{ mb: 2 }}
        itemId={item.id}
      />

      <Stack spacing={1.5} width={"100%"} {...otherProps}>
        <ConfigPackageBundleForm item={item} formid={formId} />
        <ConfigCommonSectionFormScheduling item={item} formid={formId} />
      </Stack>

      <ConfigSaveButton item={item} onSubmit={handleSubmit} disabled={!formValidTrigger} />
    </Stack>
  );
};

export default ConfigPackageBundle;
